export default "__VITE_ASSET__47c2f7d6__"